export class RadioButtons {

    /**
     * 
     * */
    _constants = Object.freeze({
        changeEventName: "radiobuttons:change",
        containerRadioButtonsSelector: ".container-radioButton",
        radioButtonInputSelector: '.container-radioButton__input-radioButton',
        radioButtonContentSelector: '.container-radioButton__content',
        radioButtonContentTextSelector: `.container-radioButton__content p` 
    })

    /**
     * @type {{el: string, onChange: (e: Event) => {}}}
     * */
    _options;

    /**
     * @type {HTMLElement}
     * */
    TargetElement

    /**
     * 
     * @param {{el: string, onChange: (e: Event) => {}}} options
     */
    constructor(options) {
        this._options = options;
        this.init()
    }

    init() {
        const el = document.querySelector(this._options.el)
        this.TargetElement = el;
        const containerRadioButtons = el.querySelectorAll(this._constants.containerRadioButtonsSelector)
        containerRadioButtons?.forEach((container) => container.addEventListener('click', (e) => { this._onChecked(e.currentTarget) }))

        const inputs = el.querySelectorAll(`${this._constants.radioButtonInputSelector}:checked`)
        inputs?.forEach((input) => input.parentElement.classList.add('checked'));

        if (this._options.onChange) {
            this.TargetElement.addEventListener(this._constants.changeEventName, this._options.onChange.bind(this))
        }
    }

    /**
     * 
     * */
    _removeCheckedClass() {
        const containerRdioButtons = this.TargetElement.querySelectorAll(this._constants.containerRadioButtonsSelector)
        containerRdioButtons.forEach((container) => container.classList.remove('checked'))
    }

    /**
     * 
     * @param {Event} e
     * @param {HTMLElement} container
     */
    _onChecked(container) {
        this._removeCheckedClass()

        /** @type {HTMLInputElement} */
        const inputCheckbox = container.firstElementChild
        inputCheckbox.checked = true

        // update checked class
        container.classList.add('checked')

        // get text content element
        const textContent = container.querySelector(this._constants.radioButtonContentTextSelector)

        // dispatch change event
        let event = new CustomEvent(this._constants.changeEventName, {
            detail: {
                checkedTarget: inputCheckbox,
                text: textContent.textContent,
                checked: inputCheckbox.checked,
                value: inputCheckbox.value,
                container: container
            }
        })
        this.TargetElement.dispatchEvent(event)
    }
}
